// =============================================================================
// FILE: TicketConfirmationPanel.js
// UPDATED: 2025-12-14
// PURPOSE:
//   Show resolution confirmation buttons for AI responses
//   - Multilingual ready (text comes from backend / parent)
//   - UI polish only – NO logic change
// =============================================================================

import React from "react";

/**
 * Props:
 *  - onConfirm(): function
 *  - onReject(): function
 *  - confirmationText?: string
 *  - confirmLabel?: string
 *  - rejectLabel?: string
 */
export default function TicketConfirmationPanel({
  onConfirm,
  onReject,
  confirmationText,
  confirmLabel,
  rejectLabel,
}) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.text}>
        {confirmationText ||
          "Does this answer your question, or would you like further assistance?"}
      </div>

      <div style={styles.actions}>
        <button
          style={{ ...styles.button, backgroundColor: "#16a34a" }}
          onClick={() => onConfirm()}
        >
          {confirmLabel || "✅ This resolves my query"}
        </button>

        <button
          style={{ ...styles.button, backgroundColor: "#dc2626" }}
          onClick={() => onReject()}
        >
          {rejectLabel || "❌ I need further help"}
        </button>
      </div>
    </div>
  );
}

// =============================================================================
// Styles
// =============================================================================
const styles = {
  wrapper: {
    marginTop: "12px",
    padding: "12px",
    borderRadius: "10px",
    backgroundColor: "#f8fafc",
    border: "1px solid #e5e7eb",
  },
  text: {
    fontSize: "14px",
    marginBottom: "12px",
    color: "#374151",
    fontWeight: 500,
    lineHeight: "1.5",
  },
  actions: {
    display: "flex",
    gap: "10px",
  },
  button: {
    flex: 1,
    border: "none",
    padding: "10px",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: 500,
  },
};
